import routes from 'routes';

const HIDDEN_ROUTES: string[] = [
  routes.eventsUrl,
  routes.performanceUrl,
  routes.partnersUrl,
];

export default HIDDEN_ROUTES;
